/**
 * Query used to get all revisions for RFXRequest detail.
 * Below are the list of services that it talks to:
    * AWSSCMRFXService
 */
import { gql } from '@apollo/client';

import { processResponse } from "./helper";

export const getAllRevisionsForRFXRequestQuery = gql `
query getAllRevisionsForRFXRequest(
    $rfxRequestId: RFXIdentifierInput!
    $nextToken: String
    $maxResults: Int
) {
    getAllRevisionsForRFXRequest(
        rfxRequestId: $rfxRequestId
        nextToken: $nextToken
        maxResults: $maxResults
    ) {
        rfxRequests {
            rfxRequestRevisionedId {
                id {
                    value
                }
                revision
            }
            rfxRequestVersion
            rfxRequestClassId {
                value
            }
            rfxResponseClassId {
                value
            }
            rfxLineItemClassId {
                value
            }
            businessId {
                value
            }
            region {
                value
            }
            beginAt
            dueAt
            name
            type
            buyer {
                value
            }
            ingestionId {
                value
            }
            commodityInformation {
                rootId {
                    value
                }
                commodityIds {
                    value
                }
                category {
                    value
                }
            }
            currency
            suppliers {
                supplierId {
                    value
                }
                supplierName {
                    value
                }
                contactId {
                    value
                }
                contactSource
                countryCode
                incoterm
                qualificationStatus
                vendorServiceCurrencies
                selectedCurrencyValid
            }
            properties {
                id {
                    value
                }
                value {
                    valueString {
                        value
                    }
                    dataType {
                        value
                    }
                }
            }
            documents {
                documentType
                supplierIds {
                    value
                }
                attachment {
                    externalId
                    version
                    filename
                    size
                    format
                    description
                    stagingS3Uri
                    status
                    createdDate {
                      value
                      format
                    }
                    lastModifiedDate {
                      value
                      format
                    }
                }
            }
            generalInformation {
                overview
                processDetail
            }
            attributes {
                acknowledgementRequirement
                ndaRequirement
                participationConfirmationRequirement
            }
            lifeCycle {
                lifeCycleGraphId
                lifeCycleState {
                    name
                    version
                }
                lifeCycleVersion
            }
          }
    }
}
`;

export default function getAllRevisionsForRFXRequest(this: any, request: any) {
    return processResponse(this.query({
        query: getAllRevisionsForRFXRequestQuery,
        variables: request
    }), 'getAllRevisionsForRFXRequest');
}
